import React, { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

interface AuthProtectedRouteProps {
  children: React.ReactElement;
}

const NetworkErrorScreen: React.FC<{ onRetry: () => void }> = ({ onRetry }) => (
  <div style={{
    display: 'flex', flexDirection: 'column', alignItems: 'center',
    justifyContent: 'center', height: '100vh', gap: '16px',
    backgroundColor: '#0a0a0a', color: '#d1d5db', fontFamily: 'sans-serif',
  }}>
    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#ef4444"
      strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="8" x2="12" y2="12" />
      <line x1="12" y1="16" x2="12.01" y2="16" />
    </svg>
    <h2 style={{ margin: 0, fontSize: '20px', fontWeight: 600, color: '#f9fafb' }}>
      Network Error
    </h2>
    <p style={{ margin: 0, fontSize: '14px', color: '#9ca3af', textAlign: 'center', maxWidth: '320px' }}>
      Unable to reach the authentication server. Check your connection and try again.
    </p>
    <button
      onClick={onRetry}
      style={{
        marginTop: '8px', padding: '10px 28px', fontSize: '14px', fontWeight: 500,
        color: '#fff', backgroundColor: '#1d4ed8', border: 'none',
        borderRadius: '6px', cursor: 'pointer',
      }}
    >
      Retry
    </button>
  </div>
);

const AuthProtectedRoute: React.FC<AuthProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading, isNetworkError, login } = useAuth();

  useEffect(() => {
    if (!isLoading && !isAuthenticated && !isNetworkError) {
      login();
    }
  }, [isLoading, isAuthenticated, isNetworkError, login]);

  if (isNetworkError) {
    return <NetworkErrorScreen onRetry={() => window.location.reload()} />;
  }

  if (isLoading || !isAuthenticated) {
    return null;
  }

  return children;
};

export default AuthProtectedRoute;
